import Breadcrumbs from "./Breadcrumbs";
import AnimatedTitle from "./AnimatedTitle";

export default function PageHero({ eyebrow, title, accent = "", underline = false, body, crumbs, children, testid = "page-hero" }) {
  return (
    <section className="relative overflow-hidden pt-10 pb-14 md:pt-14 md:pb-20 border-b border-[var(--line)] bg-white" data-testid={testid}>
      <div aria-hidden="true" className="blob blob-a -top-40 right-[-120px] h-[380px] w-[380px] bg-[#e4eadc]" />
      <div aria-hidden="true" className="blob blob-b -bottom-48 left-[-100px] h-[320px] w-[320px] bg-[#eef2e9]" />
      <div className="container-site relative">
        {crumbs && <Breadcrumbs items={crumbs} />}
        <div className="mt-6 max-w-3xl">
          {eyebrow && <span className="eyebrow fade-in">{eyebrow}</span>}
          <AnimatedTitle
            text={title}
            accent={accent}
            underline={underline}
            testid="page-title"
            baseDelay={60}
            className="mt-3 text-[2.5rem] md:text-6xl leading-[1.04] tracking-[-0.025em] text-balance"
          />
          {body && (
            <p className="slide-in mt-6 text-lg leading-relaxed text-body" style={{ animationDelay: "200ms" }}>
              {body}
            </p>
          )}
          {children && (
            <div className="fade-in" style={{ animationDelay: "480ms" }}>
              {children}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
